import type { Dispatch, SetStateAction } from "react";
import type { GhlNewPipelineDraft, LocationOption } from "@/components/admin/ghl/ghlSectionShared";

export function applyPipelineNameAutofill(
  pipelineName: string,
  locations: LocationOption[],
  setNewPipe: Dispatch<SetStateAction<GhlNewPipelineDraft>>,
  setAutofillMsg: Dispatch<SetStateAction<{ text: string; ok: boolean } | null>>,
): void {
  setAutofillMsg(null);
  if (!pipelineName || !locations.length) return;
  const lower = pipelineName.toLowerCase().trim();
  const sorted = [...locations].sort((a, b) => b.name.length - a.name.length);
  for (const loc of sorted) {
    const locLower = loc.name.toLowerCase().trim();
    if (!lower.startsWith(locLower)) continue;
    const remainder = lower.slice(locLower.length).trim();
    if (remainder) {
      setNewPipe((p) => ({ ...p, location_id: loc.id, product_type: remainder }));
      setAutofillMsg({ text: `Autofilled — ${loc.name} · ${remainder}`, ok: true });
    } else {
      setNewPipe((p) => ({ ...p, location_id: loc.id }));
      setAutofillMsg({
        text: `Location autofilled (${loc.name}) — product type not detected, fill manually.`,
        ok: false,
      });
    }
    return;
  }
  setAutofillMsg({ text: "Autofill failed — location not detected. Please fill in manually.", ok: false });
}
